import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { SupportRequestAttachmentRes } from 'src/app/core/models/searchSupportRequestList';
import { FormService, FormServiceResolver } from 'src/app/core/services/v2/form.service';
import { FormPreviewComponent } from './form-preview.component';

@Component({
  selector: 'app-form-template-preview',
  templateUrl: './form-preview.component.html',
  styleUrls: ['./form-preview.component.scss']
})
export class FormTemplatePreviewComponent extends FormPreviewComponent implements OnInit {


  constructor(private _sanitizer: DomSanitizer, private _formServiceResolver: FormServiceResolver
    ,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(_sanitizer, _formServiceResolver, data)
  };



  GetFormHtmlBlob(): Observable<Blob> {

    var obs = new Observable<Blob>(observer => {
      this._formServiceResolver.getFormService()
        .subscribe(
          (fsvc) => fsvc.getTemplateFormPreviewHtml(this.formId).subscribe(formHtml => observer.next(formHtml))
        )
    }

    );

    return obs;
  }

}
